import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import Api from '@barboxx/api';
import { Brand } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
}

interface BaseProductWatchProps {
    brand?: Brand;
}

export function BrandInput({ disabled = false }: Props) {
    const { brand } = useFormContext<BaseProductWatchProps>().getValues();

    const productQueryResult = useQuery({
        queryKey: ['brands'],
        queryFn: () =>
            Api.Products.Brands.getBrands({
                page: 0,
                size: 1000,
                sort: 'name,asc',
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: brand ? [brand] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Brand"
            name="brandId"
            loading={productQueryResult.isLoading}
            multiple={false}
            options={productQueryResult.data?.data?.results ?? []}
            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: Brand,
                    value?: Brand | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.name}`;
                },
                getOptionKey(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.id}`;
                },
            }}
        />
    );
}
